module.exports = __webpack_public_path__ + "img/background.12832f6e.png";